import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { OnboardingWrapperComponent } from './pages/onboarding/onboarding-wrapper.component';
import { LoginComponent } from './pages/onboarding/login/login.component';
import { AccountTypeComponent } from './pages/onboarding/register/account-type/account-type.component';
import { RegisterComponent } from './pages/onboarding/register/personal-details/register.component';
import { ROCCreateComponent } from './pages/onboarding/register/roc-details/roc-create.component';
import { VerifyEmailComponent } from './pages/onboarding/verify-email/verify-email.component';
import { AuthenticatedGuard, UnAuthenticatedGuard } from '@bo/ng-auth';
import { EmailVerificationComponent } from './pages/onboarding/email-verification/email-verification.component';
import { AcceptInvitationComponent } from './pages/onboarding/accept-invitation/accept-invitation.component';
import { PasswordResetRequestComponent } from './pages/onboarding/password-reset-request/password-reset-request.component';
import { PasswordResetConfirmComponent } from './pages/onboarding/password-reset-confirm/password-reset-confirm.component';
import { PageNotFoundComponent } from './shared/components/error-messages/page-not-found/page-not-found.component';

const routes: Routes = [
  {
    path: '',
    canActivate: [AuthenticatedGuard],
    children: [
      {
        path: '',
        children: [
          {
            path: '',
            pathMatch: 'full',
            redirectTo: 'roc',
          },
          {
            path: 'roc',
            loadChildren: () => import('./modules/roc/roc.module').then(m => m.ROCModule)
          },
        ]
      },
    ]
  },
  {
    path: '',
    canActivate: [UnAuthenticatedGuard],
    children: [
      {
        path: 'login',
        component: LoginComponent,
      },
      {
        path: 'sign-up',
        component: OnboardingWrapperComponent,
        children: [
          {
            path: '',
            pathMatch: 'full',
            redirectTo: 'select-account-type',
          },
          {
            path: 'select-account-type',
            component: AccountTypeComponent,
          },

          {
            path: 'personal-details',
            component: RegisterComponent,
          },
          {
            path: 'roc-details',
            component: ROCCreateComponent,
          },
        ]
      },
      {
       path: 'register',
       redirectTo: 'sign-up/select-account-type',
      },
      {
        path: 'verify-email',
        component: VerifyEmailComponent,
      },
      {
       path: 'accept-invitation',
       component: AcceptInvitationComponent,
      },
      {
        path: 'email-verification',
        component: EmailVerificationComponent,
      },
      {
        path: 'password-reset-request',
        component: PasswordResetRequestComponent,
      },
      {
        path: 'password-reset-confirm',
        component: PasswordResetConfirmComponent,
      },
    ]
  },
  {
    path: '**',
    component: PageNotFoundComponent,
    data: {
      title: 'Page Not Found'
    }
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    relativeLinkResolution: 'legacy',
    onSameUrlNavigation: 'reload',
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
